@if (lastMessage(); as message) {
    <div class="message-last" (click)="toggleExpand()">
        <ms-scoreboard-message [message]="message!" />
        @if (remainingMessages()) {
            <vn-icon
                size="12"
                class="arrow scoreboard-message-icons"
                [name]="expanded() ? 'theme-up' : 'theme-down'"
                [class.padding-right]="hasLiveAlert()" />
        }
        @if (expanded()) {
            <div class="message-list-separator"></div>
        }
    </div>
}
@if (expanded()) {
    <ng-scrollbar class="message-list" [style.background]="backgroundColor()" [viewportPropagateMouseMove]="false">
        <ng-container *rxFor="let message of remainingMessages()!; trackBy: messageTrack; let i = index">
            @if (i !== 0) {
                <div class="message-list-separator"></div>
            }
            <ms-scoreboard-message [message]="message" />
        </ng-container>
    </ng-scrollbar>
}
